import Login from "./pages/login.page";
import PasswordReset from "./pages/passwordReset.page";
import { Routes, Route } from "react-router-dom";

// CONTEXTS
import { SelectedTicketsProvider } from "./contexts/tickets/selectedTickets.context";

// LAYOUTS
import AdminLayout from "./layouts/admin/admin.layout";
import RootLayout from "./layouts/root.layout";
// -- ADMIN LAYOUTS --
import AssetAdminLayout from "./pages/admin/assets/layout.asset.admin.page";
import PermissionLayout from "./pages/admin/users/permissions/layout.permissions.page";
// ---------------
// -- UNAUTHENTICATED LAYOUTS --
import UnauthenticatedPasswordResetLayout from "./pages/users/passwordReset/unauthenticated/layout.unauthenticated.passwordReset.user.page";
// -- PAGE LAYOUTS --
import ShippingLayout from "./pages/shipping/layout.shipping.page";
import AssetsLayout from "./pages/assets/layout.assets.page";
import PartsLayout from "./layouts/parts/parts.layout";
import ProductsLayout from "./pages/products/layout.products.page";
import StatementsLayout from "./pages/statements/layout.statement.page";
import CustTicketsLayout from "./pages/statements/layout.CustTicketsLayout.page.jsx";
import ManualStatementLayout from "./pages/statements/layout.manualstatement.page";

import UsersLayout from "./layouts/users/users.layout";
import OpenPartsLayout from "./pages/parts/openParts/layout.openParts.page";
import OrderedPartsLayout from "./pages/parts/orderedParts/layout.orderedParts.page";
import AdvancedQueryLayout from "./pages/advancedQuery/layout.advancedQuery.page";
import ReportsLayout from "./pages/reports/layout.reports.page";
import TicketsLayout from "./pages/tickets/layout.tickets.page";

function App() {
  return (
    <Routes>
      <Route path="/" element={<RootLayout />}>
        <Route path="/admin" element={<AdminLayout />}>
          <Route path="assets" element={<AssetAdminLayout />} />
          <Route path="user-permissions" element={<PermissionLayout />} />
          <Route path="user-roles" element={<></>} />
        </Route>
        <Route path="/assets" element={<AssetsLayout />} />
        <Route path="/parts" element={<PartsLayout />}>
          <Route path="open" element={<OpenPartsLayout />} />
          <Route path="ordered" element={<OrderedPartsLayout />} />
        </Route>
        <Route path="/tickets" element={<TicketsLayout />} />
        <Route path="/shipping" element={<ShippingLayout />} />
        <Route path="/products" element={<ProductsLayout />} />
        <Route path="/statements" element={<StatementsLayout />} />
        <Route path="/custticekt" element={<CustTicketsLayout />} />
        <Route path="/manualstatement" element={<ManualStatementLayout />} />
        
        <Route path="/open" element={<OpenPartsLayout />} />
        <Route path="/test" element={<AdvancedQueryLayout />} />
        <Route path="/login" element={<Login />} />
        <Route path="/ordered" element={<OrderedPartsLayout />} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route path="/reports" element={<ReportsLayout />} />
        <Route path="/users" element={<UsersLayout />} />
      </Route>
      <Route
        path="/reset-password/:token/:email"
        element={<UnauthenticatedPasswordResetLayout />}
      />
    </Routes>
  );
}

export default App;
